import { render, staticRenderFns } from "./LastTicketsActions.vue?vue&type=template&id=a7b79e64&scoped=true"
import script from "./LastTicketsActions.vue?vue&type=script&lang=js"
export * from "./LastTicketsActions.vue?vue&type=script&lang=js"
import style0 from "./LastTicketsActions.vue?vue&type=style&index=0&id=a7b79e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b79e64",
  null
  
)

export default component.exports